import React, { useEffect, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient'; // Adjust import based on your project structure
import { AuthContext } from '../context/AuthContext'; // Import your AuthContext

export default function InviteHandler() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const { user } = useContext(AuthContext); // Access the logged-in user

  useEffect(() => {
    const processInvite = async () => {
      if (!token) {
        alert('Invalid or missing invitation token.');
        navigate('/dashboard'); // Redirect to home or another appropriate page
        return;
      }

      try {
        // Validate the token via backend API
        const response = await fetch(
          'https://nodejs-serverless-function-express-azure-delta.vercel.app/api/validate-invite',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
          }
        );

        const data = await response.json();

        if (!response.ok || !data.invite) {
          alert('Invalid or expired invitation token.');
          navigate('/'); // Redirect if token is invalid
          return;
        }

        if (user) {
          // If the user is logged in, check if the invite matches their email
          if (data.invite.email === user.email) {
            alert('Invitation processed successfully!');
            navigate(`/dashboard`); // Redirect to dashboard or relevant page
          } else {
            alert('This invitation is not associated with your account.');
            navigate('/dashboard');
          }
        } else {
          // If no user is logged in, redirect to onboarding
          navigate('/onboarding');
        }
      } catch (error) {
        console.error('Error processing invitation:', error);
        alert('Failed to process invitation.');
        navigate('/');
      }
    };    

    processInvite();
  }, [token, navigate]);

  return (
    <div className="loading-container">
      <p>Processing your invitation...</p>
    </div>
  );
}